import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import { PageTabRail } from '../../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { TabbedNavigationGroup } from '../../../../../../../../../../../components/router/router-tabbed-navigation';
import {
  CnsAssetDaysTable,
  type CnsAssetDaysTableHeaderProps,
} from '../../../../../../../../../../../features/dtcc/cns/asset-day/cns-asset-days-table';
import { getPageHead } from '../../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day/$assetId/')({
  head: () => getPageHead('CNS Asset Days'),
  component: CnsSingleAssetDaysList,
});

function TableHeader({ filter, search }: CnsAssetDaysTableHeaderProps) {
  return (
    <VerticalStack gap={7}>
      <PageTabRail
        actions={
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            {filter}
          </HorizontalStack>
        }
        group={TabbedNavigationGroup.ClearingOperationsDtcc}
      />

      {search}
    </VerticalStack>
  );
}

function CnsSingleAssetDaysList() {
  const { assetId } = Route.useParams();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <CnsAssetDaysTable assetId={assetId} HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
